import CountryPageRenderer from '../components/CountryPageRenderer';
import armeniaData from '../data/country-pages/armenia';

export default function ArmeniaCountryPage() {
  return <CountryPageRenderer data={armeniaData} />;
}
